<template>
  <!-- <div class="tabs">
    <div
      class="tabs__item"
      :class="{ 'tabs__item--active': active == 'mount' }"
      @click="changeView('mount')"
    >
      <svg class="icon">
        <use xlink:href="/images/svg/symbols.svg#svg-month-icon"></use>
      </svg>
      {{ $t("controls.month") }}
    </div>
    <div
      class="tabs__item"
      :class="{ 'tabs__item--active': active == 'week' }"
      @click="changeView('week')"
    >
      <svg class="icon">
        <use xlink:href="/images/svg/symbols.svg#svg-week-icon"></use>
      </svg>
      Week
    </div>
    <div
      class="tabs__item"
      :class="{ 'tabs__item--active': active == 'day' }"
      @click="changeView('day')"
    >
      <svg class="icon">
        <use xlink:href="/images/svg/symbols.svg#svg-day-icon"></use>
      </svg>
      {{ $t("controls.day") }}
    </div>
  </div>-->
  <div class="tabs mr-12" :class="{
    'tabs_light': !isDark
    }">
    <div
      class="tabs-item"
      @click="changeView('mount')"
      :class="{
		'tabs-item_active': 'mount' === active
	}"
    >
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        :stroke="getColor('mount')"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse cx="22.1399" cy="18.2728" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="18.3982" cy="18.2728" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="18.3982" cy="22.0909" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="14.6565" cy="22.0909" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="18.3982" cy="14.4546" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="22.1399" cy="14.4546" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.8127 27V7.75321C24.8127 6.63429 24.0852 5.72723 23.1877 5.72723H6.12502C5.22755 5.72723 4.5 6.63429 4.5 7.75321V27H24.8127Z"
          :stroke="getColor('mount')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <ellipse cx="14.6565" cy="14.4546" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="14.6565" cy="18.2728" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <path
          d="M7.70752 5.45455C7.70752 4.09894 8.78448 3 10.113 3C11.4415 3 12.5184 4.09894 12.5184 5.45455C12.5184 6.81015 11.4415 7.90909 10.113 7.90909"
          :stroke="getColor('mount')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.3291 5.45455C17.3291 4.09894 18.4061 3 19.7346 3C21.0631 3 22.14 4.09894 22.14 5.45455C22.14 6.81015 21.0631 7.90909 19.7346 7.90909"
          :stroke="getColor('mount')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <ellipse cx="14.6565" cy="11.1819" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="18.3982" cy="11.1819" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="22.1399" cy="11.1819" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <path
          d="M5.13172 25.2338H24.8054"
          :stroke="getColor('mount')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <ellipse cx="7.17261" cy="14.4546" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="10.9143" cy="14.4546" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="7.17261" cy="18.2728" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="7.17261" cy="22.0909" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="10.9143" cy="18.2728" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
        <ellipse cx="10.9143" cy="22.0909" rx="1.06909" ry="1.09091" :fill="getColor('mount')" />
      </svg>

      <!-- <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.7482 5.8163C13.7482 5.8163 13.2478 2.7509 10.933 2.53199C10.9017 2.50072 10.9955 2 10.2133 2C9.43153 2 9.52535 2.50072 9.49408 2.53199C7.17957 2.7509 6.67885 5.8163 6.67885 5.8163L6.27231 6.28575C6.55376 7.44282 10.2133 7.44282 10.2133 7.44282C10.2133 7.44282 13.8733 7.44282 14.1547 6.28575L13.7482 5.8163Z"
          :stroke="getColor('mount')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.1978 7.9903C8.99313 7.9903 7.85061 7.82667 6.82589 7.53467C6.77499 7.75212 6.74808 7.97757 6.74808 8.2092C6.74808 9.10592 7.15025 9.91645 7.79715 10.4961C8.06151 11.6877 9.04295 12.5728 10.2135 12.5728C11.384 12.5728 12.3654 11.6877 12.6298 10.4961C13.2771 9.91645 13.6792 9.10592 13.6792 8.2092C13.6792 7.97466 13.6516 7.7463 13.5992 7.52631C12.5669 7.82376 11.4142 7.9903 10.1978 7.9903Z"
          :stroke="getColor('mount')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.5468 12.9637C14.4519 12.3383 12.5752 11.6187 12.5752 11.6187C12.5752 11.6187 11.668 12.995 10.1978 12.995C8.72765 12.995 7.82039 11.6187 7.82039 11.6187C7.82039 11.6187 5.94369 12.3383 4.84917 12.9637C3.75427 13.5895 2.94083 15.6226 3.00338 16.78C3.81682 17.9375 10.1978 18 10.1978 18C10.1978 18 16.5788 17.9375 17.3922 16.78C17.4548 15.6226 16.6417 13.5895 15.5468 12.9637Z"
          :stroke="getColor('mount')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.72488 13.0264L6.85105 12.5883V14.9969H5.72488V13.0264Z"
          :stroke="getColor('mount')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.7334 13.0264L13.6073 12.5883V14.9969H14.7334V13.0264Z"
          :stroke="getColor('mount')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.1978 17.4681C10.1978 17.4681 13.2691 17.4379 15.4218 17.0332V16.071C15.4218 15.7372 15.1509 15.4663 14.8167 15.4663H5.64155C5.30774 15.4663 5.03683 15.7372 5.03683 16.071V17.0448C7.18589 17.4386 10.1978 17.4681 10.1978 17.4681Z"
          :stroke="getColor('mount')"
          stroke-linejoin="round"
        />
      </svg>-->

      <div class="tabs-item__text">
        <span>{{ $t('controls.month') }}</span>
      </div>
    </div>

    <div
      class="tabs-item"
      @click="changeView('week')"
      :class="{
		'tabs-item_active': 'week' === active
	}"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19 19.5V4.36578C19 3.48595 18.3553 2.77271 17.56 2.77271H2.44C1.64471 2.77271 1 3.48595 1 4.36578V19.5H19Z"
          :stroke="getColor('week')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.8418 2.54545C3.8418 1.41578 4.79614 0.5 5.97338 0.5C7.15061 0.5 8.10495 1.41578 8.10495 2.54545C8.10495 3.67513 7.15061 4.59091 5.97338 4.59091"
          :stroke="getColor('week')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.3682 2.54545C12.3682 1.41578 13.3225 0.5 14.4997 0.5C15.677 0.5 16.6313 1.41578 16.6313 2.54545C16.6313 3.67513 15.677 4.59091 14.4997 4.59091"
          :stroke="getColor('week')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle cx="13" cy="14.5" r="1.5" :fill="getColor('week')" />
        <circle cx="7" cy="14.5" r="1.5" :fill="getColor('week')" />
        <circle cx="7" cy="9.5" r="1.5" :fill="getColor('week')" />
        <circle cx="13" cy="9.5" r="1.5" :fill="getColor('week')" />
      </svg>

      <!-- <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.6 2C7.27083 2 6.2385 3.38706 6.2385 5.41525C6.18782 5.63177 6.16095 5.85674 6.16095 6.08786C6.16095 6.98198 6.56175 7.78972 7.20672 8.36712C7.47046 9.55532 8.44866 10.4375 9.61574 10.4375C10.7824 10.4375 11.7606 9.55532 12.0244 8.36712C12.6694 7.78972 13.0705 6.98198 13.0705 6.08786C13.0705 5.85406 13.0425 5.62602 12.9907 5.4068C12.9907 2.99087 11.9603 2 9.6 2Z"
        :stroke="getColor('week')"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.2461 12.6833C14.0902 12.0229 12.1088 11.2632 12.1088 11.2632C12.1088 11.2632 11.6466 14.9291 9.59923 16.9105C7.48543 14.8957 7.08924 11.2632 7.08924 11.2632C7.08924 11.2632 5.10789 12.0229 3.95194 12.6833C2.79599 13.3436 1.93719 15.4904 2.00361 16.7124C2.86202 17.934 9.59923 18 9.59923 18C9.59923 18 16.3361 17.934 17.1945 16.7124C17.2605 15.4904 16.4021 13.3436 15.2461 12.6833Z"
        :stroke="getColor('week')"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.83951 12.4521H10.3256L10.0945 13.5417H9.07062L8.83951 12.4521Z"
        :stroke="getColor('week')"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.3256 14.8628L9.6319 16.3819L8.83951 14.8628L9.07062 13.7733H10.0941L10.3256 14.8628Z"
        :stroke="getColor('week')"
        stroke-linejoin="round"
      />
      <path
        d="M7.66714 2.44574C7.66714 2.44574 8.79008 5.58304 10.6063 5.55002C13.0883 5.50511 12.9827 5.05478 12.9827 5.05478"
        :stroke="getColor('week')"
        stroke-linejoin="round"
      />
      <path
        d="M8.72385 4.39417C8.72385 4.39417 7.83241 6.01234 6.24725 5.41805"
        :stroke="getColor('week')"
        stroke-linejoin="round"
      />
      </svg>-->

      <div class="tabs-item__text">
        <span>Woche</span>
      </div>
    </div>

    <div
      class="tabs-item"
      @click="changeView('day')"
      :class="{
		'tabs-item_active': 'day' === active
	}"
    >
      <!-- <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.7482 5.8163C13.7482 5.8163 13.2478 2.7509 10.933 2.53199C10.9017 2.50072 10.9955 2 10.2133 2C9.43153 2 9.52535 2.50072 9.49408 2.53199C7.17957 2.7509 6.67885 5.8163 6.67885 5.8163L6.27231 6.28575C6.55376 7.44282 10.2133 7.44282 10.2133 7.44282C10.2133 7.44282 13.8733 7.44282 14.1547 6.28575L13.7482 5.8163Z"
          :stroke="getColor('day')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.1978 7.9903C8.99313 7.9903 7.85061 7.82667 6.82589 7.53467C6.77499 7.75212 6.74808 7.97757 6.74808 8.2092C6.74808 9.10592 7.15025 9.91645 7.79715 10.4961C8.06151 11.6877 9.04295 12.5728 10.2135 12.5728C11.384 12.5728 12.3654 11.6877 12.6298 10.4961C13.2771 9.91645 13.6792 9.10592 13.6792 8.2092C13.6792 7.97466 13.6516 7.7463 13.5992 7.52631C12.5669 7.82376 11.4142 7.9903 10.1978 7.9903Z"
          :stroke="getColor('day')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.5468 12.9637C14.4519 12.3383 12.5752 11.6187 12.5752 11.6187C12.5752 11.6187 11.668 12.995 10.1978 12.995C8.72765 12.995 7.82039 11.6187 7.82039 11.6187C7.82039 11.6187 5.94369 12.3383 4.84917 12.9637C3.75427 13.5895 2.94083 15.6226 3.00338 16.78C3.81682 17.9375 10.1978 18 10.1978 18C10.1978 18 16.5788 17.9375 17.3922 16.78C17.4548 15.6226 16.6417 13.5895 15.5468 12.9637Z"
          :stroke="getColor('day')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.72488 13.0264L6.85105 12.5883V14.9969H5.72488V13.0264Z"
          :stroke="getColor('day')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.7334 13.0264L13.6073 12.5883V14.9969H14.7334V13.0264Z"
          :stroke="getColor('day')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.1978 17.4681C10.1978 17.4681 13.2691 17.4379 15.4218 17.0332V16.071C15.4218 15.7372 15.1509 15.4663 14.8167 15.4663H5.64155C5.30774 15.4663 5.03683 15.7372 5.03683 16.071V17.0448C7.18589 17.4386 10.1978 17.4681 10.1978 17.4681Z"
          :stroke="getColor('day')"
          stroke-linejoin="round"
        />
      </svg>-->
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19 19.5V4.36578C19 3.48595 18.3553 2.77271 17.56 2.77271H2.44C1.64471 2.77271 1 3.48595 1 4.36578V19.5H19Z"
          :stroke="getColor('day')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.8418 2.54545C3.8418 1.41578 4.79614 0.5 5.97338 0.5C7.15061 0.5 8.10495 1.41578 8.10495 2.54545C8.10495 3.67513 7.15061 4.59091 5.97338 4.59091"
          :stroke="getColor('day')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.3682 2.54545C12.3682 1.41578 13.3225 0.5 14.4997 0.5C15.677 0.5 16.6313 1.41578 16.6313 2.54545C16.6313 3.67513 15.677 4.59091 14.4997 4.59091"
          :stroke="getColor('day')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <ellipse cx="9.95526" cy="11.7955" rx="3.95526" ry="3.79545" :fill="getColor('day')" />
      </svg>

      <div class="tabs-item__text">
        <span>{{ $t('controls.day') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['active'],
    computed: {
        ...mapGetters({
            activeTheme: 'activeTheme',
        }),
        isDark() {
            return this.activeTheme === 'dark'
        },
    },
    methods: {
        changeView(view) {
            this.$emit('changeView', view)
        },
        getColor(tab) {
            if (tab === this.active) {
                return this.isDark ? '#000' : '#304156'
            }

            return this.isDark ? '#fff' : '#304156'
        },
    },
}
</script>
<style lang="scss" scoped>
// @import "src/assets/sass/main";

// .tabs {
//   display: inline-flex;
//   align-items: center;
//   &__item {
//     width: 110px;
//     height: 50px;
//     display: flex;
//     justify-content: center;
//     background-color: #ffffff;
//     align-items: center;
//     font-size: 14px;
//     color: #4d4d4d;
//     box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//     box-sizing: border-box;
//     cursor: pointer;
//     transition: background-color 0.5s;
//     & .icon {
//       width: 20px;
//       height: 20px;
//       color: $primaryColor;
//       margin-right: 11px;
//     }
//     &--active {
//       border: 2px solid #e0e0e0;
//       background-color: rgba(97, 66, 45, 0.05);
//       box-shadow: none;
//       & .icon {
//         color: #000;
//       }
//     }
//     &:first-of-type {
//       border-radius: 8px 0 0 8px;
//     }
//     &:last-of-type {
//       border-radius: 0 8px 8px 0;
//     }
//   }
// }
</style>
